import { LoanPeriod } from "../../../constants/Constants";
import { convertToDollar, convertToFloat } from "./SaleFunctions";
// Leasefunctions
//export const calculateResidualValue = (msrp, residualFactor, mileageCharge) => {
export const calculateResidualValue = (msrp, residualFactor) => {
	let ressValue = msrp * residualFactor;
	// if (ressValue - mileageCharge >= 0) {
	// 	console.log("ressValue - mileageCharge >= 0");
	// 	ressValue = msrp * residualFactor - mileageCharge;
	// }
	// console.log({ ressValue });
	return convertToDollar(ressValue);
};
export const calculateResidualFactor = (residualValue, msrp) => {
	return msrp / residualValue;
};

export const calculateDepreciation = (capCost, residualValue) => {
	return convertToDollar(capCost - residualValue);
};

export const calculateBasePayment = (depreciation, rentCharge) => {
	return convertToDollar(depreciation + rentCharge);
};

export const calculateMonthlyTax = (capSalesTax, basePayment, taxRate) => {
	if (capSalesTax) return convertToDollar(basePayment * taxRate, 2);
	else return 0;
};

export function aprFromMoneyFactor(moneyFactor, periodsPerYear = 12) {
	const mf = Number(moneyFactor) || 0;
	const p = Number(periodsPerYear) || 12;
	// Inverse of: MF = (APR% / 100) / (2 * p)
	// => APR% = MF * 2 * p * 100
	return mf * 2 * p * 100;
}
export function moneyFactorFromApr(aprPercent, periodsPerYear = 12) {
	console.log(aprPercent, periodsPerYear);
	const p = Number(periodsPerYear) || 12;
	const aprDec = Number(aprPercent) || 0;
	// MF = APR / (2 * periodsPerYear)
	return aprDec / (2 * p);
}
export function calculateCapCost(lease, sale) {
	let capCost =
		lease.price +
		sale.aftmkt +
		sale.collisionTotPremium +
		sale.payoff +
		lease.mileageCharge;
	if (lease.capDMVFee) capCost += sale.totalDMVFees;
	if (lease.capBankFee) capCost += lease.bankFee;
	if (lease.capGAPWaiver) capCost += lease.gapWaiver;
	if (lease.capWarranty) capCost += sale.warranty;
	if (lease.capDocFee) capCost += lease.docfee ?? 0;
	if (lease.capMiscFee) capCost += lease.miscFee;
	if (lease.capOtherfee) capCost += lease.otherFee;
	if (lease.capDispositionFee) capCost += lease.disposition;
	if (lease.capSmogFees)
		capCost += sale.dealerSmog + sale.stateSmog + sale.smogImpact;
	if (capCost < 0.01) capCost = 0;
	return capCost;
}
export function calculateTotalTax(monthlyTax, lease) {
	return monthlyTax * lease.term + lease.downTax;
}
export function calculateAdditionalTax(lease, sale, dealTaxSettings) {
	let additionalTax = 0;
	if (!lease.capGAPWaiver && dealTaxSettings.gapTaxRate > 0)
		additionalTax += sale.gap;
	if (!lease.capWarranty && dealTaxSettings.warrantyTaxRate > 0)
		additionalTax += sale.warranty;
	if (dealTaxSettings.AftrMrktTaxRate > 0) additionalTax += sale.aftmkt;
	if (!lease.capDocFee && dealTaxSettings.docFeeTaxRate > 0)
		additionalTax += lease.docfee ?? 0;
	if (!lease.capMiscFee) additionalTax += lease.miscFee;
	if (!lease.capOtherfee) additionalTax += lease.otherFee;
	if (!lease.capDispositionFee) additionalTax += lease.disposition;

	return additionalTax;
}
export function calculateMiscFee(deal) {
	let sum = 0.0;
	deal.miscSellerFees.forEach((key) => {
		if (key.isTaxable) {
			sum += key.amount;
		}
	});
	return sum;
}
export function calculateOtherFee(deal) {
	let nonTaxSum = 0.0;
	deal.miscSellerFees.forEach((key) => {
		if (!key.isTaxable) {
			nonTaxSum += key.amount;
		}
	});
	return nonTaxSum;
}
export function Days2PayInterest(d) {
	////	daysPerPeriod=	LoanPeriod[loanPeriod].daysInPeriod

	//   Dim rtn As Single
	//   Dim DailyInt As Double

	//   rtn = 0
	//   DailyInt = Lease.APR / 365

	//   if () d < daysPerPeriod() Then ' Credit
	//     rtn = -1 * (daysPerPeriod() - d) * DailyInt

	//   ElseIf d = daysPerPeriod() Then
	//     rtn = 0

	//   Else ' D > daysPerPeriod
	//     rtn = (d - daysPerPeriod()) * DailyInt

	//   End If

	return rtn;
}
